import { useState } from "react";
import Container from 'react-bootstrap/Container';
import { useTranslation } from "react-i18next";
import { DropdownAtom, ModalAtom } from "../../../components/atoms/atom";
import { getSalesOrderNumbersFromSelectedOrders } from "../constant";

function SelectPriorityModal(props) {
	const { show, onClose, onSubmit, selectedOrders, priorityList = [] } = props;
	const { t } = useTranslation();
	// Use priorityId from selected order if single selection
	const defaultPriority = selectedOrders?.length === 1 ? selectedOrders[0].priorityId : '';
	const [priorityObj, setPriorityObj] = useState({
		value: defaultPriority,
		error: '',
	});

	// Convert priorityList to dropdown options with position in brackets
	const priorityOptions = priorityList.map((p, index) => ({
		label: `${p.label} (${index + 1})`,
		value: p.id,
		priority: p.priority,
	}));

	const submitPriority = () => {
		// Allow null/empty priority to clear it
		onSubmit(priorityObj.value);
	}

	return (
		<ModalAtom
			title={t('change-priority-for-order', { commaSeparatedSalesOrderNumbers: getSalesOrderNumbersFromSelectedOrders(selectedOrders) })}
			show={show}
			handleClose={onClose}
			handleSubmit={submitPriority}
			saveText={t('save')}
			body={<Container>
				<div className='body-inner'>
					<span>{t('action-select-priority')}</span>
					<span>
						<DropdownAtom
							className='form-control'
							value={priorityObj.value}
							error={priorityObj.error}
							options={priorityOptions}
							onChange={(e) => setPriorityObj({
								...priorityObj,
								value: e.target.value,
								error: ''
							})}
							sortOptions={false}
							shouldTranslate={false}
						/>
					</span>
				</div>
			</Container>}
		/>
	);
}

export default SelectPriorityModal;
